// Must stay first: fixes the asset base for the published preview build (no-op in production builds).
if (process.env.REACT_APP_PREVIEW === "1") require("@/preview/publicPath");
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
